(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["flamingo-currency-estimate"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.FlamingoCurrency) return;

    var CACHE_KEY = 'flamingo_fx_v2';
    var CACHE_TTL_MS = 24 * 60 * 60 * 1000;
    var state = { currency: null, rate: null };

    var COUNTRY_CURRENCY = {
      AE: 'AED', SA: 'SAR', QA: 'QAR', KW: 'KWD', BH: 'BHD', OM: 'OMR', JO: 'JOD', LB: 'LBP',
      US: 'USD', CA: 'CAD', GB: 'GBP', AU: 'AUD', NZ: 'NZD', SG: 'SGD', HK: 'HKD',
      JP: 'JPY', CN: 'CNY', CH: 'CHF', SE: 'SEK', NO: 'NOK', DK: 'DKK', PL: 'PLN',
      ZA: 'ZAR', MY: 'MYR', TH: 'THB', ID: 'IDR', PH: 'PHP', VN: 'VND', KR: 'KRW',
      MX: 'MXN', BR: 'BRL', RU: 'RUB', TR: 'TRY', IL: 'ILS', EG: 'EGP', NG: 'NGN',
      PK: 'PKR', BD: 'BDT', LK: 'LKR', NP: 'NPR',
      DE: 'EUR', FR: 'EUR', IT: 'EUR', ES: 'EUR', NL: 'EUR', BE: 'EUR', IE: 'EUR',
      PT: 'EUR', AT: 'EUR', FI: 'EUR', GR: 'EUR', LU: 'EUR', MT: 'EUR', CY: 'EUR',
      SI: 'EUR', SK: 'EUR', EE: 'EUR', LV: 'EUR', LT: 'EUR', HR: 'EUR'
    };

    function readCache() {
      try {
        var raw = localStorage.getItem(CACHE_KEY);
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (!data || Date.now() - data.ts > CACHE_TTL_MS) return null;
        return data;
      } catch (e) {
        return null;
      }
    }

    function writeCache(data) {
      try {
        localStorage.setItem(
          CACHE_KEY,
          JSON.stringify({ currency: data.currency, rate: data.rate, ts: Date.now() })
        );
      } catch (e) {}
    }

    function fetchJson(url) {
      return fetch(url, { credentials: 'omit', referrerPolicy: 'no-referrer' }).then(function (res) {
        if (!res.ok) throw new Error('bad status');
        return res.json();
      });
    }

    function fetchText(url) {
      return fetch(url, { credentials: 'omit', referrerPolicy: 'no-referrer' }).then(function (res) {
        if (!res.ok) throw new Error('bad status');
        return res.text();
      });
    }

    // Three independent, redundant sources for the visitor's country —
    // if one is blocked by an ad blocker or privacy tool, the next is tried.
    function detectCountryCode() {
      return fetchText('https://www.cloudflare.com/cdn-cgi/trace')
        .then(function (text) {
          var match = text.match(/loc=([A-Z]{2})/);
          if (!match) throw new Error('no loc');
          return match[1];
        })
        .catch(function () {
          return fetchJson('https://ipwho.is/').then(function (data) {
            if (!data || !data.country_code) throw new Error('no country');
            return data.country_code;
          });
        })
        .catch(function () {
          return fetchJson('https://ipapi.co/json/').then(function (data) {
            var code = data && (data.country_code || data.country);
            if (!code) throw new Error('no country');
            return code;
          });
        });
    }

    // Static-file CDN first (very unlikely to be blocked), API fallback second.
    function fetchRate(baseCurrency, targetCurrency) {
      var base = baseCurrency.toLowerCase();
      var target = targetCurrency.toLowerCase();

      return fetchJson(
        'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/' + base + '.json'
      )
        .then(function (data) {
          var rate = data && data[base] && data[base][target];
          if (!rate) throw new Error('no rate');
          return rate;
        })
        .catch(function () {
          return fetchJson('https://open.er-api.com/v6/latest/' + baseCurrency.toUpperCase()).then(function (data) {
            var rate = data && data.rates && data.rates[targetCurrency.toUpperCase()];
            if (!rate) throw new Error('no rate');
            return rate;
          });
        });
    }

    function renderEstimate(el) {
      var baseCurrency = el.getAttribute('data-fx-currency') || 'INR';
      var cents = Number(el.getAttribute('data-fx-cents') || 0);

      if (!state.currency || !state.rate || state.currency === baseCurrency || !cents) {
        el.hidden = true;
        return;
      }

      var estimate = (cents / 100) * state.rate;
      var formatted;
      try {
        formatted = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: state.currency,
          maximumFractionDigits: estimate >= 100 ? 0 : 2
        }).format(estimate);
      } catch (e) {
        formatted = state.currency + ' ' + Math.round(estimate);
      }

      el.textContent = '≈ ' + formatted;
      el.title =
        'Estimated in ' + state.currency + '. You are charged in ' + baseCurrency + ' at checkout — your bank or card network converts the amount.';
      el.hidden = false;
    }

    function renderAll() {
      document.querySelectorAll('[data-fx-cents]').forEach(renderEstimate);
    }

    function update(el, cents) {
      if (!el) return;
      el.setAttribute('data-fx-cents', String(cents));
      renderEstimate(el);
    }

    function init() {
      var cached = readCache();
      if (cached && cached.currency && cached.rate) {
        state.currency = cached.currency;
        state.rate = cached.rate;
        renderAll();
        return;
      }

      detectCountryCode()
        .then(function (code) {
          var currency = COUNTRY_CURRENCY[String(code || '').toUpperCase()];
          if (!currency || currency === 'INR') return;
          state.currency = currency;

          return fetchRate('INR', currency).then(function (rate) {
            state.rate = rate;
            writeCache({ currency: currency, rate: rate });
            renderAll();
          });
        })
        .catch(function () {});
    }

    window.FlamingoCurrency = { update: update };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["flamingo-glossary-tooltip"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.FlamingoGlossary) return;

    function loadTerms() {
      var terms = [];
      document.querySelectorAll('[data-glossary-terms]').forEach(function (script) {
        try {
          var parsed = JSON.parse(script.textContent);
          parsed.forEach(function (item) {
            if (item.term && item.definition) terms.push(item);
          });
        } catch (e) {}
      });
      // Longest term first so overlapping phrases match the more specific one.
      terms.sort(function (a, b) { return b.term.length - a.term.length; });
      return terms;
    }

    function escapeRegExp(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function makeTermSpan(matchedText, definition) {
      var span = document.createElement('span');
      span.className = 'flamingo-glossary-term';
      span.tabIndex = 0;
      span.setAttribute('role', 'button');
      span.setAttribute('aria-label', matchedText + ' — glossary term, activate for definition');
      span.appendChild(document.createTextNode(matchedText));

      var tooltip = document.createElement('span');
      tooltip.className = 'flamingo-glossary-tooltip';
      tooltip.setAttribute('role', 'tooltip');
      tooltip.textContent = definition;
      span.appendChild(tooltip);

      span.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          span.click();
        }
      });

      return span;
    }

    function wrapTermsInNode(node, terms, seen) {
      if (node.nodeType === Node.ELEMENT_NODE) {
        if (node.closest && node.closest('.flamingo-glossary-term')) return;
        if (/^(SCRIPT|STYLE|A|BUTTON)$/.test(node.tagName)) return;
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          wrapTermsInNode(child, terms, seen);
        });
        return;
      }

      if (node.nodeType !== Node.TEXT_NODE || !node.nodeValue.trim()) return;

      for (var i = 0; i < terms.length; i++) {
        var item = terms[i];
        if (seen.has(item.term)) continue;

        var re = new RegExp('(' + escapeRegExp(item.term) + ')', 'i');
        var match = node.nodeValue.match(re);
        if (!match) continue;

        var idx = match.index;
        var before = node.nodeValue.slice(0, idx);
        var matched = match[1];
        var after = node.nodeValue.slice(idx + matched.length);

        var span = makeTermSpan(matched, item.definition);

        var parent = node.parentNode;
        var afterNode = document.createTextNode(after);
        parent.insertBefore(document.createTextNode(before), node);
        parent.insertBefore(span, node);
        parent.insertBefore(afterNode, node);
        parent.removeChild(node);

        seen.add(item.term);
        // Continue scanning the remainder of this text node for other terms.
        wrapTermsInNode(afterNode, terms, seen);
        return;
      }
    }

    function closeAll(except) {
      document.querySelectorAll('.flamingo-glossary-term.is-open').forEach(function (el) {
        if (el !== except) el.classList.remove('is-open');
      });
    }

    function init() {
      var terms = loadTerms();
      if (!terms.length) return;

      var scanRoots = document.querySelectorAll(
        '[data-pdp-description], .flamingo-pdp__accordion-body'
      );
      scanRoots.forEach(function (root) {
        if (root.dataset.glossaryScanned === '1') return;
        root.dataset.glossaryScanned = '1';
        var seen = new Set();
        wrapTermsInNode(root, terms, seen);
      });
    }

    document.addEventListener('click', function (event) {
      var term = event.target.closest ? event.target.closest('.flamingo-glossary-term') : null;
      if (term) {
        var isOpen = term.classList.contains('is-open');
        closeAll(term);
        term.classList.toggle('is-open', !isOpen);
      } else {
        closeAll();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll();
    });

    window.FlamingoGlossary = { init: init };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["flamingo-product-card-cart"] && !Shopify.designMode) return;
  try {
    const FLAMINGO_ADDED_RESET_MS = 1500;
  const FLAMINGO_ERROR_RESET_MS = 2000;

  function clearProductCardAddReset(button) {
    const timeoutId = button.dataset.resetTimeoutId;
    if (!timeoutId) return;

    clearTimeout(Number(timeoutId));
    delete button.dataset.resetTimeoutId;
  }

  function scheduleProductCardAddReset(button, delay) {
    clearProductCardAddReset(button);

    const timeoutId = setTimeout(() => {
      delete button.dataset.resetTimeoutId;
      button.classList.remove('is-added', 'is-error');
      setProductCardAddButtonState(button, 'default');
    }, delay);

    button.dataset.resetTimeoutId = String(timeoutId);
  }

  function setProductCardAddButtonState(button, state) {
    const config = {
      default: { label: 'labelDefault', aria: 'ariaDefault' },
      loading: { label: 'labelLoading', aria: 'ariaLoading' },
      added: { label: 'labelAdded', aria: 'ariaAdded' },
      error: { label: 'labelError', aria: 'ariaError' }
    }[state];

    if (!config) return;

    const label = button.dataset[config.label];
    if (label) button.textContent = label;

    const ariaLabel = button.dataset[config.aria];
    if (ariaLabel) button.setAttribute('aria-label', ariaLabel);
  }

  function updateHeaderCartCount(count) {
    const cartLink = document.querySelector('[data-cart-count]');
    if (!cartLink) return;

    let sup = cartLink.querySelector('sup');
    if (count > 0) {
      if (!sup) {
        sup = document.createElement('sup');
        cartLink.prepend(sup);
      }
      sup.textContent = count;
    } else if (sup) {
      sup.remove();
    }
  }

  async function addProductCardToCart(button) {
    const variantId = button.dataset.variantId;
    if (!variantId || button.dataset.busy === 'true') return;

    clearProductCardAddReset(button);
    button.classList.remove('is-added', 'is-error');

    button.dataset.busy = 'true';
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    setProductCardAddButtonState(button, 'loading');

    try {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      });
      if (!addRes.ok) throw new Error('Add to cart failed');

      const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (cartRes.ok) {
        const cart = await cartRes.json();
        updateHeaderCartCount(cart.item_count);
      }

      button.classList.remove('is-loading');
      button.classList.add('is-added');
      setProductCardAddButtonState(button, 'added');
      scheduleProductCardAddReset(button, FLAMINGO_ADDED_RESET_MS);
    } catch (error) {
      console.error('Add to cart error:', error);
      button.classList.remove('is-loading');
      button.classList.add('is-error');
      setProductCardAddButtonState(button, 'error');
      scheduleProductCardAddReset(button, FLAMINGO_ERROR_RESET_MS);
    } finally {
      button.dataset.busy = 'false';
      button.removeAttribute('aria-busy');
    }
  }

  window.addProductCardToCart = addProductCardToCart;

  if (!window.FlamingoProductCardCartBound) {
    window.FlamingoProductCardCartBound = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-product-add]');
      if (!button || button.disabled || button.closest('[data-carousel-clone]')) return;

      event.preventDefault();
      event.stopPropagation();
      addProductCardToCart(button);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
